module.exports = __webpack_public_path__ + "static/media/history-green.fd115530.svg";